export default class news {
  constructor() {
    $('.nav .news .kash').click(function(e){
      e.preventDefault();
      if(!window.preventClick) {
        $('.nav .news').toggleClass('open');
        $('.nav--main').toggleClass('news-open');
        $('.news-container').slideToggle(200);
      }
    });

    $('.news-close').click(function(e){
      e.preventDefault();
      if(!window.preventClick) {
        $('.nav .news').removeClass('open');
        $('.nav--main').removeClass('news-open');
        $('.news-container').slideUp(200);
      }
    });

    $('.news-article--title').click(function(e){
      $(this).siblings('.news-article--text').slideToggle(200);
    });
  }
}
